// extracted by mini-css-extract-plugin
export default {"audit_container":"Audit_audit_container__DeiHv","audit_task_board_container":"Audit_audit_task_board_container__bhKyB"};